// extracted by mini-css-extract-plugin
module.exports = {"taxBudgetCard":"Card-module__taxBudgetCard--35re6","container":"Card-module__container--3g_4O","start":"Card-module__start--yp8_N","end":"Card-module__end--3PD_E"};